import React from 'react'

export default function PortalFallbackPrint({ onClose }) {
  return (
    <div style={ov.overlay} className="pfp-overlay">
      <style>{`
        @media print {
          body * { visibility: hidden; }
          .pfp-printarea, .pfp-printarea * { visibility: visible; }
          .pfp-printarea { position: absolute; left: 0; top: 0; width: 100%; }
          .pfp-noprint { display: none !important; }
          .pfp-step { page-break-inside: avoid; }
        }
      `}</style>
      <div style={ov.modal}>
        <div style={ov.header} className="pfp-noprint">
          <div style={{fontSize:16,fontWeight:700}}>🖨️ Hoja de respaldo — si el portal falla</div>
          <div style={{display:'flex',gap:8}}>
            <button style={ov.printBtn} onClick={()=>window.print()}>🖨️ Imprimir</button>
            <button style={ov.closeBtn} onClick={onClose}>×</button>
          </div>
        </div>

        <div style={ov.body} className="pfp-printarea">
          <div style={{textAlign:'center',marginBottom:8}}>
            <div style={{fontSize:20,fontWeight:800,color:'#202124'}}>🐈 Kitty's Cleaning Services</div>
            <div style={{fontSize:14,color:'#5f6368',marginTop:2}}>Guía de respaldo — usa esto solo si el portal no funciona</div>
          </div>
          <div style={{fontSize:12,color:'#c05050',textAlign:'center',marginBottom:20,fontWeight:600}}>
            Anota todo en papel y avisa a Yosi por WhatsApp cuando el portal vuelva a funcionar, para que se pueda registrar todo.
          </div>

          <Step n="1" title="Al llegar a la casa">
            Haz un recorrido completo de la casa antes de empezar. Anota la hora de llegada.
          </Step>
          <Step n="2" title="Revisa lo esperado">
            Lee las notas del cliente y el checklist de esta visita antes de comenzar. Si el cliente te dice algo importante, anótalo en papel para pasárselo a Yosi después.
          </Step>
          <Step n="3" title="Estima el tiempo">
            Antes de empezar a limpiar, anota cuántas horas crees que va a tomar esta casa. Si crees que va a tomar más de 30 minutos extra de lo normal, anota por qué (ej: muy sucio, desordenado) y toma una foto si puedes.
          </Step>
          <Step n="4" title="Haz la limpieza y completa el checklist">
            Marca cada tarea del checklist conforme la vayas terminando. No firmes hasta que todo esté completo.
          </Step>
          <Step n="5" title="Firma">
            Escribe tus iniciales y la hora en que terminaste, en la hoja de esta casa.
          </Step>
          <Step n="6" title="Anota la hora de salida">
            Escribe la hora exacta en que te vas de la casa.
          </Step>
          <Step n="7" title="Antes de la siguiente casa">
            Si vas a llegar antes de la hora programada en la próxima casa, anota si prefieres tomar un descanso o si estás lista para empezar antes — para que Yosi le pregunte al cliente.
          </Step>
          <Step n="8" title="Al final del día">
            Regresa el equipo que usaste. Anota si algo se dañó o falta equipo. Nos vemos mañana — espera la confirmación por mensaje.
          </Step>

          <div style={{marginTop:24,padding:'14px 16px',background:'#fff8e1',borderRadius:10,border:'1px solid #ffe082'}}>
            <div style={{fontSize:12,fontWeight:700,color:'#854f0b',marginBottom:6}}>📋 Anota por cada casa:</div>
            <div style={{fontSize:12,color:'#5a4000',lineHeight:1.7}}>
              Casa: _______________________&nbsp;&nbsp;&nbsp; Hora de llegada: _______<br/>
              Estimado de horas: _______&nbsp;&nbsp;&nbsp; Hora de salida: _______<br/>
              Checklist completo: ☐ Sí &nbsp;&nbsp; Firma/Iniciales: _______<br/>
              Notas del cliente / problemas: ___________________________________
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function Step({ n, title, children }) {
  return (
    <div className="pfp-step" style={{ display:'flex', gap:12, marginBottom:14 }}>
      <div style={{ width:28, height:28, borderRadius:'50%', background:'#e8547a', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:800, flexShrink:0 }}>
        {n}
      </div>
      <div>
        <div style={{ fontSize:14, fontWeight:700, color:'#202124', marginBottom:2 }}>{title}</div>
        <div style={{ fontSize:13, color:'#5f6368', lineHeight:1.5 }}>{children}</div>
      </div>
    </div>
  )
}

const ov = {
  overlay: {position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:500, display:'flex', alignItems:'center', justifyContent:'center'},
  modal: {background:'#fff', borderRadius:14, width:'94vw', maxWidth:700, maxHeight:'92vh', display:'flex', flexDirection:'column', overflow:'hidden', boxShadow:'0 20px 60px rgba(0,0,0,0.3)'},
  header: {display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 20px', borderBottom:'1px solid #e3e5e8', flexShrink:0},
  printBtn: {padding:'8px 16px', border:'none', borderRadius:8, background:'#e8547a', color:'#fff', fontWeight:600, fontSize:13, cursor:'pointer'},
  closeBtn: {fontSize:22, border:'none', background:'none', cursor:'pointer', color:'#9aa0a6'},
  body: {overflowY:'auto', padding:'24px 28px'},
}
